import React, { useContext } from "react";

import { Button } from "@/components/Form";
import LocaleContext from "@/i18n";
import { isMobilePhone } from "@/utils/getters";

import {
  ButtonWrap,
  ContentBox,
  Image,
  Section,
  Text,
  Title,
  Wrapper,
} from "./styles";

export type AnswerSlideProps = {
  answerText?: string;
  answerImage?: string;
  isCorrect?: boolean;
  onButtonClick?: () => void;
};

const AnswerSlide: React.FC<AnswerSlideProps> = (
  props: AnswerSlideProps
): React.JSX.Element => {
  const localeContext = useContext(LocaleContext);
  const { translation } = localeContext;
  const renderImage = (): React.JSX.Element => {
    // load always as small as possible images from images-service "dali" because of caching and speed
    const maxImageWidth = isMobilePhone() ? 480 : 560;
    const imageUrl = `${props.answerImage}?width=${maxImageWidth}`;
    return <Image alt={""} src={imageUrl} $showOnlyImage={!props.answerText} />;
  };

  return (
    <Section $isCorrect={props.isCorrect}>
      <Wrapper>
        <Title>
          {props.isCorrect
            ? translation.answerSlide.correctAnswer
            : translation.answerSlide.wrongAnswer}
        </Title>
        <ContentBox>
          <Text>{props.answerText}</Text>
          {props.answerImage && renderImage()}
          <ButtonWrap>
            <Button onClick={props.onButtonClick}>
              {translation.answerSlide.next}
            </Button>
          </ButtonWrap>
        </ContentBox>
      </Wrapper>
    </Section>
  );
};

export default AnswerSlide;
